import { c as _c } from "react/compiler-runtime";
import { getOrgPlaybooksGalleryOptions } from '@onefootprint/fetch-dashboard';
import { Button, Pagination } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate';
import usePlaybooks from './hooks/use-playbooks';
import Table from './table';
const Playbooks = () => {
  const $ = _c(45);
  const {
    t
  } = useTranslation("playbooks");
  const {
    data: response,
    errorMessage,
    isPending,
    pagination
  } = usePlaybooks();
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...getOrgPlaybooksGalleryOptions(),
      staleTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useQuery(t0);
  let t1;
  if ($[1] !== router) {
    t1 = () => {
      router.push("/playbooks/new");
    };
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOpen = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <Head><title>{t2}</title></Head>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp2);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <p className="text-heading-2 text-primary fp-text">{t4}</p>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp3);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <p className="text-body-2 text-secondary fp-text">{t6}</p>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <div className="flex flex-col gap-1 max-w-[650px]">{t5}{t7}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp4);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t(_temp5);
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== handleOpen || $[23] !== t10) {
    t11 = <Button onClick={handleOpen}>{t10}</Button>;
    $[22] = handleOpen;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t9) {
    t12 = <div className="relative"><PermissionGate scopeKind="onboarding_configuration" fallbackText={t9}>{t11}</PermissionGate></div>;
    $[25] = t11;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t8) {
    t13 = <div className="flex flex-col items-start gap-4 sm:flex-row sm:justify-between sm:items-center">{t8}{t12}</div>;
    $[28] = t12;
    $[29] = t8;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = response?.data;
  let t15;
  if ($[31] !== errorMessage || $[32] !== isPending || $[33] !== t14) {
    t15 = <Table data={t14} errorMessage={errorMessage} isPending={isPending} />;
    $[31] = errorMessage;
    $[32] = isPending;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== pagination || $[36] !== response) {
    t16 = response && response.meta.count > 0 && <Pagination hasNextPage={pagination.hasNextPage} hasPrevPage={pagination.hasPrevPage} onNextPage={pagination.loadNextPage} onPrevPage={pagination.loadPrevPage} pageIndex={pagination.pageIndex} pageSize={pagination.pageSize} totalNumResults={response.meta.count} />;
    $[35] = pagination;
    $[36] = response;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = <div className="flex flex-col">{t15}{t16}</div>;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t13 || $[42] !== t17 || $[43] !== t3) {
    t18 = <div className="flex flex-col gap-8">{t3}{t13}{t17}</div>;
    $[41] = t13;
    $[42] = t17;
    $[43] = t3;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};
export default Playbooks;
function _temp($) {
  return $.pageTitle;
}
function _temp2($_0) {
  return $_0.header.title;
}
function _temp3($_1) {
  return $_1.header.subtitle;
}
function _temp4($_2) {
  return $_2.ctaNotAllowed;
}
function _temp5($_3) {
  return $_3.createButton;
}